export const AccountURL = {
    login: 'Login',
    forgotPassword: 'Forgot-Password',
    resetPassword: 'Reset-Password',
    signUp: 'Sign-Up',
}